/**
 * /rewards — Rewards & Wallet page (points balance, ledger, redeem flow).
 *
 * Sits under _protected so only authenticated customers can reach it.
 */
import { createFileRoute } from '@tanstack/react-router';
import { RewardsPage } from '@/features/rewards/rewards-page';

export const Route = createFileRoute('/_protected/rewards')({
  component: RewardsPage,
});
